import BaseService from '_services/rest/base';

class ProductService extends BaseService {
  constructor() {
    super();
  }

  deleteProduct(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteType(productId, id) {
    return this.request(`${this.getUrl()}/${productId}/type/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteEquipment({ entityId, equipmentId }) {
    return this.request(`${this.getUrl()}/${entityId}/equipment/${equipmentId}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/product`;
  }

  getUrlSave(id, url) {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search, slug: params.slug };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductTypeOptions() {
    return this.request(`${this.getUrl()}/type`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getEquipments(name) {
    return this.request(`${this.getUrl()}/equipment`, { search: name })
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  save(product) {
    const meta = this.getUrlSave(product.id, '');
    return this.request(meta.url, product, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveEntity(service, slug) {
    const meta = this.getUrlSave(service.id, `/type/${slug}`);

    return this.request(meta.url, service, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveEquipment(id, equipment) {
    const method = equipment.id === null ? 'post' : 'put';
    return this.request(`${this.getUrl()}/${id}/equipment`, equipment, method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
  saveTypeOption(type) {
    return this.request(`${this.getUrl()}/type`, type, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ProductService();
